import { useSelector } from 'react-redux';
import { LocalStorageKeys } from '@constants/enums';
import { selectAuthState } from '../layout/login/auth/selectors';
import useClearStorageService from '@/layout/login/hooks/useClearStorage.service';
import { getAuthToken, isLegacyAuth } from '@/services/auth/authUtils';

const useIsLogged = () => {
  const userAuth = useSelector(selectAuthState);
  const { clearWhiteLabelStorage } = useClearStorageService();

  const isTokenExpired = (tokenToValidate: string | null): boolean => {
    if (!tokenToValidate) return false;
    try {
      const expiry = JSON.parse(atob(tokenToValidate.split('.')[1])).exp;
      const isExpired = Math.floor(new Date().getTime() / 1000) >= expiry;
      if (isExpired) {
        const onboardingData = localStorage.getItem(
          LocalStorageKeys.ONBOARDING_PROCESS_DATA
        );
        clearWhiteLabelStorage();
        if (onboardingData) {
          localStorage.setItem(
            LocalStorageKeys.ONBOARDING_PROCESS_DATA,
            onboardingData
          );
        }
      }
      return isExpired;
    } catch {
      return true;
    }
  };

  const token = getAuthToken();
  const hasValidReduxToken = isLegacyAuth()
    ? !!userAuth.token
    : !!userAuth.idToken;

  return !!(token && !isTokenExpired(token) && hasValidReduxToken);
};

export default useIsLogged;
